module.exports = __webpack_public_path__ + "img/icon8-2@2x.74491b37.png";